export default __webpack_public_path__ + "static/media/washington.28574cf6.svg";